<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить запись</span>
              <span v-else> <div>Добавить запись</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-autocomplete
              ref="responsible"
              :error="hasError('person')"
              :error-messages="getError('person')"
              :items="selectors.person"
              no-data-text="Нет данных"
              label="Лицо"
              v-model="value.person"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('role')"
              :error-messages="getError('role')"
              :items="choices.role"
              label="Роли"
              v-model="value.role"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('dissertationCouncil')"
              :error-messages="getError('dissertationCouncil')"
              :items="selectors.dissertationCouncil"
              label="Диссертационный совет"
              v-model="value.dissertationCouncil"
              no-data-text ="Нет данных"
            ></v-autocomplete>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import urls from "../../../../../modules/petition/urls"
  import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
  import {makeGetRequest,makePostRequest} from "../../../../../helper";
  import urlsW from "../../../../../modules/petition/urlsW.js"
  import urlsU from "../../../../../modules/petition/urlsU.js"

  export default {
    name: "Role",
    mixins: [UserDataFormMixin],
    props: [ 'id', 'worker', 'role','dissertationCouncil',],

    data() {
      return {
        URL_CREATE: urls.getUrl('admin|permissions|models|role_person-list', 'create'),
        URL_UPDATE:  urls.getUrl('admin|permissions|models|role_person-detail', 'update'),

        loaders: {
          person: {
            status: true,
            handler: () => this.load(this, urls.getUrl('admin|core|selectors|person', 'get'))
          },
        },
        value: {
          id: this.id || '',
          person:this.person || '',
          role:this.role || null,
          dissertationCouncil:this.dissertationCouncil || '',
        },
        choices:{
          role:[]
        },
        selectors:{
          dissertationCouncil:[],
          person: [],
        },
      }
    },
    methods: {
      load: function(app, url) {
        if(url === null) {
          app.loaders.person.status = false;
          return;
        }
        makeGetRequest(url)
          .then(resp => resp.json())
          .then(json => {
            let users = [];
            let results = [];
            let next_url = null;
            if(json['next'] !== null)
              next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
            for(let i in json['results']){
              app.selectors.person.push(Object.assign({}, json['results'][i]));
            }
            app.load(app, next_url);

          });
      },
      loadSelector(data,url){
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }) .then(json => {
          this.selectors[data] = json
        })
      },
      closeDialog() {
        this.$emit('ended', '')
      },
    },
    created() {
      let url =  urls.getUrl('admin|diss|selectors|dissertation_council', 'get')
      this.loadSelector("dissertationCouncil",url)


      let role_choices = urls.getUrl('admin|permissions|choices|role_choices', 'get')
      let sys = true
      makeGetRequest(role_choices).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        this.choices.role= json.filter(currentValue => currentValue.value > 2)
      })

      this.loaders.person.handler();
    }
  }

</script>

<style scoped>

</style>
